import { styled, css } from 'styled-components';
import { Button } from '@sendible/design-system';
import { motion } from 'framer-motion';

export const Container = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    display: flex;
    margin-left: -0.75rem;
    overflow-x: visible;
    position: relative;
    width: calc(100% + 1.5rem);

    .nav-button {
      background: ${colors.brandLight};
      box-shadow:
        0px 1px 18px 0px ${colors.brandDarkAlpha10},
        0px 6px 10px 0px ${colors.brandDarkAlpha15},
        0px 3px 5px -1px ${colors.brandDarkAlpha20};
      margin-top: -1rem;
      position: absolute;
      z-index: 100;

      &:hover {
        background: ${colors.brandLight};
        transform: scale(1.1);
      }
    }

    .attach-prev {
      left: 0.75rem;
    }

    .attach-next {
      right: 0.75rem;
    }
  `}
`;

export const MotionButton = styled(motion.create(Button))``;

export const Slider = styled.div<{ $isSorting: boolean; $isEmpty?: boolean }>`
  ${({ theme: { colors }, $isSorting, $isEmpty }) => css`
    align-items: center;
    display: flex;
    gap: 1rem;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: scroll;
    padding: 0.25rem 0.75rem 0.75rem;
    scroll-behavior: smooth;
    scroll-padding: 0 0.75rem;
    width: 100%;

    ${
      $isEmpty &&
      css`
        display: none;
      `
    }

    ${
      !$isSorting &&
      css`
        scroll-snap-type: x mandatory;
      `
    }

    ${
      $isSorting &&
      css`
        button {
          cursor: grabbing !important;
        }
      `
    }

    .skeleton {
      height: 6.5rem;
      width: 6.5rem;
    }

    &::-webkit-scrollbar {
      height: 1rem;
      width: 1rem;
    }

    &::-webkit-scrollbar-track {
      background: white;
    }

    &::-webkit-scrollbar-thumb {
      background-clip: padding-box;
      background-color: ${colors.brandDarkTint90};
      border-radius: 0.5rem;
      border: 0.25rem solid white;
      -webkit-border-radius: 0.5rem;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: ${colors.brandDarkTint70};
    }
  `}
`;

export const MediaSlot = styled(motion.div)`
  flex-shrink: 0;
  height: 7.5rem;
  margin: 0;
  padding: 0;
  position: relative;
  scroll-snap-align: start;
  width: 6.5rem;
`;
